'use client';

import { useEffect } from 'react';
import { useLocale } from 'next-intl';
import { currentZone } from '@portal-root/geo-utils';

export const CookieManager = () => {
  const locale = useLocale();

  useEffect(() => {
    document.cookie = `external-locale=${locale}; domain=${currentZone}; path=/; expires=Tue, 19 Jan 2038 03:14:07 GMT`;
  }, [locale]);

  return null;
};
